import Model from "./abstract/Model";
import Address from "./Address";

export default class Person extends Model {
  email;
  gender;
  name;
  phone;
  phone_country_id;
  
  address = new Address;
  
  constructor(props) {
    super();

    this.initializeAttributes(props, {
      'address': Address,
    });
  }
}
